// src/pages/PurchasesTokensList.jsx
import { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
} from "firebase/firestore";
import { db } from "../firebaseConfig";

function formatTimestamp(ts) {
  if (!ts) return "-";
  // Firestore Timestamp tiene toDate()
  const d = typeof ts.toDate === "function" ? ts.toDate() : new Date(ts);
  return d.toLocaleString();
}

export default function PurchasesTokensList() {
  const [rows, setRows] = useState([]);
  const [lastDoc, setLastDoc] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState("");

  const PAGE_SIZE = 25;

  const fetchFirstPage = async () => {
    setLoading(true);
    setError("");
    try {
      const ref = collection(db, "purchases_tokens");
      const q = query(ref, orderBy("processedAt", "desc"), limit(PAGE_SIZE));
      const snap = await getDocs(q);

      const data = snap.docs.map((d) => ({
        id: d.id,
        processedAt: d.data().processedAt ?? null,
        productId: d.data().productId ?? "",
        uid: d.data().uid ?? "",
      }));

      setRows(data);
      setLastDoc(snap.docs.length ? snap.docs[snap.docs.length - 1] : null);
    } catch (e) {
      console.error(e);
      setError(e?.message || "Error cargando compras.");
    } finally {
      setLoading(false);
    }
  };

  const fetchNextPage = async () => {
    if (!lastDoc) return;
    setLoadingMore(true);
    setError("");
    try {
      const ref = collection(db, "purchases_tokens");
      const q = query(
        ref,
        orderBy("processedAt", "desc"),
        startAfter(lastDoc),
        limit(PAGE_SIZE)
      );
      const snap = await getDocs(q);

      const data = snap.docs.map((d) => ({
        id: d.id,
        processedAt: d.data().processedAt ?? null,
        productId: d.data().productId ?? "",
        uid: d.data().uid ?? "",
      }));

      setRows((prev) => [...prev, ...data]);
      setLastDoc(snap.docs.length ? snap.docs[snap.docs.length - 1] : null);
    } catch (e) {
      console.error(e);
      setError(e?.message || "Error cargando más compras.");
    } finally {
      setLoadingMore(false);
    }
  };

  useEffect(() => {
    fetchFirstPage();
  }, []);

  return (
    <div style={{ padding: 16, maxWidth: 1100, margin: "0 auto" }}>
      <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
        <h2 style={{ margin: 0 }}>Compras de Tokens</h2>
        <button onClick={fetchFirstPage} disabled={loading}>
          {loading ? "Cargando..." : "Refrescar"}
        </button>
      </div>

      <p style={{ color: "#666", marginTop: 6 }}>
        Colección: <b>purchases_tokens</b> (ordenadas por <b>processedAt</b>)
      </p>

      {error ? (
        <div style={{ marginTop: 12, color: "crimson" }}>{error}</div>
      ) : null}

      <div
        style={{
          marginTop: 12,
          border: "1px solid #e5e5e5",
          borderRadius: 10,
          overflow: "hidden",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead style={{ background: "#fafafa" }}>
            <tr>
              <th style={th}>processedAt</th>
              <th style={th}>productId</th>
              <th style={th}>uid</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td style={td} colSpan={3}>
                  Cargando…
                </td>
              </tr>
            ) : rows.length === 0 ? (
              <tr>
                <td style={td} colSpan={3}>
                  No hay compras.
                </td>
              </tr>
            ) : (
              rows.map((r) => (
                <tr key={r.id}>
                  <td style={td}>{formatTimestamp(r.processedAt)}</td>
                  <td style={td}>{r.productId || "-"}</td>
                  <td style={td}>{r.uid || "-"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div style={{ marginTop: 14, display: "flex", gap: 10 }}>
        <button
          onClick={fetchNextPage}
          disabled={!lastDoc || loadingMore || loading}
        >
          {loadingMore ? "Cargando..." : "Cargar más"}
        </button>

        <div style={{ color: "#666", alignSelf: "center" }}>
          Mostrando: <b>{rows.length}</b>
        </div>
      </div>
    </div>
  );
}

const th = {
  textAlign: "left",
  padding: "10px 12px",
  fontSize: 14,
  borderBottom: "1px solid #e5e5e5",
};

const td = {
  padding: "10px 12px",
  fontSize: 14,
  borderBottom: "1px solid #f0f0f0",
};
